import { Record } from "immutable";

const CustomerAdminRecord = Record({
  id: null,
  customerId: null,
  adminKey: "",
  adminName: "",
  mail: "",
  memo: "",
  lockVersion: 0
});

class CustomerAdmin extends CustomerAdminRecord {
  isNew() {
    return this.id === null;
  }

  validation() {
    const messages = [];

    if (this.adminKey === "") {
      messages.push("担当者IDを入力してください。");
    }
    if (this.adminName === "") {
      messages.push("担当者名を入力してください。");
    }
    if (this.mail === "") {
      messages.push("メールアドレスを入力してください。");
    }

    return messages;
  }
}

export default CustomerAdmin;



// WEBPACK FOOTER //
// ./src/models/CustomerAdmin.js